<template>
  <div
    v-if="title.length && imageUrl && plansColumns.length"
    v-lazy:background-image="imageUrl"
    class="header-container d-flex plans-wrapper"
  >
    <div class="hero-plans-title w-100 mt-3 plans-wrapper">
      <prismic-rich-text :field="title" :style="titleStyle"></prismic-rich-text>
      <prismic-rich-text
        v-if="subtitle.length"
        class="hero-plans-title w-100 mt-3 plans-wrapper"
        :style="subtitleStyle"
        :field="subtitle"
      ></prismic-rich-text>

      <BRow>
        <BCol
          v-for="(plansColumn, index) in plansColumns"
          :key="'textColumn-' + index"
          class="plans-wrapper hero-plan"
        >
          <div v-if="plansColumn.title.length" class="d-flex plans-wrapper">
            <prismic-rich-text :field="plansColumn.title" :style="titleStyle"></prismic-rich-text>
          </div>
          <div v-if="plansColumn.subtitle.length" class="mb-3 d-flex plans-wrapper">
            <prismic-rich-text
              :field="plansColumn.subtitle"
              class="prismic-plan-column plans-subtitle-text"
              :style="subtitleStyle"
            ></prismic-rich-text>
          </div>

          <div
            v-if="plansColumn.buttonText && plansColumn.buttonPath"
            class="d-flex plans-wrapper m-3"
          >
            <Button :to="plansColumn.buttonPath" color="green" size="big">
              {{ plansColumn.buttonText }}
            </Button>
          </div>
          <div v-if="plansColumn.amountText.length" class="d-flex plans-wrapper mt-3 mb-3">
            <prismic-rich-text
              :field="plansColumn.amountText"
              :style="subtitleStyle"
            ></prismic-rich-text>
          </div>
        </BCol>
      </BRow>
    </div>
  </div>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue';
import Button from 'UI/Button';

export default {
  components: {
    BCol,
    BRow,
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: '',
      buttonPath: '',
      buttonText: '',
      contentAlign: '',
      imageAlt: '',
      imageUrl: '',
      plansColumns: [],
      subtitle: '',
      subtitleColor: '',
      title: '',
      titleColor: ''
    };
  },
  computed: {
    subtitleStyle() {
      return { color: this.subtitleColor };
    },
    titleStyle() {
      return { color: this.titleColor };
    }
  },
  created() {
    const { primary } = this.slice;
    const plans = this.slice.items;

    this.contentAlign = primary.content_align ? primary.content_align : '';
    this.imageAlt = primary.image.alt;
    this.imageUrl = primary.image.url;
    this.subtitle = primary.subtitle;
    this.subtitleColor = primary.subtitle_color ? primary.subtitle_color : 'black';
    this.title = primary.title1[0]?.text ? primary.title1 : '';
    this.titleColor = primary.title_color ? primary.title_color : 'black';

    plans.forEach((el) => {
      const planColumn = {
        amountText: el.amount_text,
        subtitle: el.plan_subtitle,
        title: el.plan_title,
        buttonPath: el.button_path && el.button_path[0]?.text,
        buttonText: el.button_text && el.button_text[0]?.text
      };

      this.plansColumns.push(planColumn);
    });
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  border-radius: 5px;
  height: auto;
  width: 100%;
  overflow: hidden;
  position: relative;
  background-size: cover;
}
.hero-plan {
  margin: 0px 30px;
  @include xl {
    flex: 0 0 100%;
    margin: 0px;
    max-width: 100%;
  }
}
.hero-plans-title {
  padding: 30px;
  z-index: 1;
  @include lg {
    padding: 10px;
  }
}
.plans-subtitle-text {
  @include lg {
    font-size: 15px !important;
  }
}
.plans-wrapper {
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}
.prismic-plan-column {
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0px;
  opacity: 1;
  padding-bottom: 10px;
  @include xl {
    height: auto;
  }
  @include sm {
    font-size: 16px;
  }
}
.w-lg-auto {
  @include lg {
    width: auto !important;
  }
}
</style>
